<template>
  <basic-container>
    <div
      class="path-container"
      style="margin-bottom: 20px; padding: 10px 15px; border-radius: 4px"
    >
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>客服工作站</el-breadcrumb-item>
        <el-breadcrumb-item>用户反馈与优化</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <avue-crud
      :option="option"
      :data="data"
      ref="crud"
      v-model="form"
      :page.sync="page"
      @refresh-change="refreshChange"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @on-load="(page) => onLoad(page, params)"
      @row-save="saveFeedBack"
      @row-update="updateFeedBack"
      @row-del="deleteFeedBack"
      :header-cell-class-name="headerCellClassName"
    >
      <template slot="menuLeft"> </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { remove, enable } from "@/api/health/userjk";
import {
  getFeedBacks,
  saveOrUpdateFeedBack,
  deleteFeedBack,
} from "@/api/health/manage";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      params: {
        channel: window.localStorage.getItem("channel"),
      },
      form: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      headerCellClassName: 'headerClass',
      option: {
        indexLabel: "序号",
        tip: false,
        border: false,
        index: true,
        viewBtn: true,
        editBtn: true,
        addBtn: true,
        addBtnText: "新 增 数 据",
        delBtn: true,
        selection: false,
        searchEnter: true,
        searchMenuSpan: 4,
        column: [
          {
            label: "反馈类型",
            prop: "type",
            search: true,
            type: "select",
            searchSpan: 5,
            dicData: [
              { label: "建议", value: 0 },
              { label: "投诉", value: 1 },
              { label: "功能需求", value: 2 },
            ],
          },
          {
            label: "提交时间",
            prop: "submitDate",
            type: "datetime",
            format: "yyyy-MM-dd HH:mm",
            valueFormat: "yyyy-MM-dd HH:mm:ss",
            // search: true,
          },
          {
            label: "处理状态",
            prop: "status",
            search: true,
            type: "select",
            searchSpan: 5,
            dicData: [
              { label: "待处理", value: 0 },
              { label: "处理中", value: 1 },
              { label: "已关闭", value: 2 },
            ],
          },
          {
            label: "关联工单ID",
            prop: "workId",
            search: true,
            searchLabelWidth: 100,
            searchSpan: 5
          },
          {
            label: "优化建议",
            prop: "record",
            search: true,
            overHidden: true,
            searchSpan: 5
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(["permission"]),
    permissionList() {
      return {
        addBtn: this.permission.health_userjk_add,
        viewBtn: this.permission.health_userjk_view,
        delBtn: this.permission.health_userjk_delete,
        editBtn: this.permission.health_userjk_edit,
      };
    },
    ids() {
      const ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(",");
    },
  },
  methods: {
    onLoad(page, params) {
      console.log("onLoad?");
      params.channel = window.localStorage.getItem("channel");
      getFeedBacks(page.currentPage, page.pageSize, params).then((res) => {
        const data = res.data;
        this.page.total = data.total;
        this.data = data.feedBacks;
      });
    },

    saveFeedBack(row, done, loading) {
      console.log("save?");
      row.channel = window.localStorage.getItem("channel");
      saveOrUpdateFeedBack(row)
        .then((res) => {
          done();
          this.onLoad(this.page, this.params);
          this.$message({
            type: "success",
            message: "添加成功!",
          });
        })
        .catch(() => {
          this.params = {
            channel: window.localStorage.getItem("channel"),
          };
          this.onLoad(this.page, this.params);
        });
    },

    updateFeedBack(row, index, done, loading) {
      // row.channel = window.localStorage.getItem("channel");
      if (row.id == null) {
        done();
        this.$message.success("数据未修改!");
        return;
      }
      saveOrUpdateFeedBack(row)
        .then(() => {
          done();
          this.onLoad(this.page, this.params);
          this.$message({
            type: "success",
            message: "修改成功!",
          });
        })
        .catch(() => {
          loading();
        });
    },

    deleteFeedBack(row) {
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return deleteFeedBack(row);
        })
        .then(() => {
          this.onLoad(this.page, this.params);
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        });
    },

    searchReset() {
      this.params = {
        channel: window.localStorage.getItem("channel"),
      };
      this.page.currentPage = 1;
      this.onLoad(this.page, this.params);
    },

    searchChange(params, done) {
      console.log("SeachChange?");
      params.channel = window.localStorage.getItem("channel");
      this.params = params;
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
      done();
    },

    selectionChange(list) {
      this.selectionList = list;
    },

    refreshChange(data) {
      this.onLoad(this.page, data.searchForm);
    },

    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return remove(this.ids);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          this.$refs.crud.toggleSelection();
        });
    },

    handleEnable() {
      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }
      this.$confirm("确定对该用户启用VIP嘛?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return enable(this.ids);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          this.$refs.crud.toggleSelection();
        });
    },

    archiveType(row) {
      console.log(row);
      const parameter = {
        wxUserId: row.wxUserId,
      };
      this.$router.push({
        path: "/health/archiveType",
        query: parameter,
      });
    },
    handleDetail(data) {
      this.$router.push({
        path: "/health/bpmeterdata_detail",
        query: {
          wxUserId: data.id,
          meterDate: this.params.meterDate,
          jkStatus: data.jkStatus,
        },
      });
    },
    datashow(row) {
      const parameter = {
        wxUserId: row.wxUserId,
      };
      this.$router.push({
        path: "/customer/datashow",
        query: parameter,
      });
    },
  },
};
</script>
<style>
.headerClass{
      background-color: #409EFF !important;
      color:#FFF !important;
    }
</style>
